import '../styles/MainBody.css';
import RouterSwitch from './RouterSwitch';

const MainBody: React.FC = () => {
    // Listen for aside state (open/collapsed) via a custom event or class on body
    // We'll use a CSS class on body for simplicity
    return (
      <div className="main-body adaptive-main-body">
        <div className="box">
          <RouterSwitch />
        </div>
      </div>
    );
}

export default MainBody;
